import OperationsAnalytics from "@onesolution/pages/app/_layout/Analytics/Operations";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/_layout/analytics/operations")({
	component: RouteComponent,
});

function RouteComponent() {
	return <OperationsAnalytics />;
}
